/**
 * CoevaluationItem Component
 *
 * Features:
 * - Displays a single user activity for coevaluation.
 * - Handles peer evaluation button logic and disables if already evaluated.
 * - Uses i18next for translations.
 * - Uses CSS modules for styling and Material-UI for UI.
 */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';

import classes from './CoevaluationUserItem.module.css';

const CoevaluationItem = props => {
  const { t } = useTranslation(['lesson']);
  // State to indicate if the activity has been coevaluated
  const [activityCoevaluated, setActivityCoevaluated] =
    useState(false);
  useEffect(() => {
    props.activitiesCoevaluated.map(item => {
      if (item === props.homeworkData.idUserHomework) {
        setActivityCoevaluated(true);
      }
    });
  }, [props.activitiesCoevaluated]);

  return (
    <>
      <li className={classes.item}>
        <p className={classes.title}>{props.homeworkData.title}</p>
        <Button
          disabled={
            activityCoevaluated ||
            !(props.coevaluation === 0 && props.evals <= 6)
          }
          onClick={props.coevalUser(
            props.homeworkData.title,
            props.homeworkData.path,
            props.homeworkData.idUserHomework
          )}
          className={classes.coevalBtn}
        >
          {activityCoevaluated ||
          (props.coevaluation === 0 && props.evals <= 6)
            ? t('peer_evaluate')
            : t('peered')}
        </Button>
      </li>
    </>
  );
};

CoevaluationItem.propTypes = {
  /**
   * Function to handle peer evaluation
   */
  coevalUser: PropTypes.func,
  /**
   * Homework data object
   */
  homeworkData: PropTypes.object,
  /**
   * Number of evaluations
   */
  evals: PropTypes.number,
  /**
   * Coevaluation status
   */
  coevaluation: PropTypes.number,
  /**
   * Array of already coevaluated activities
   */
  activitiesCoevaluated: PropTypes.array
};

CoevaluationItem.defaultProps = {
  coevalUser: () => {},
  homeworkData: {},
  evals: 0,
  coevaluation: 0,
  activitiesCoevaluated: []
};

export default CoevaluationItem;
